module.exports = __webpack_public_path__ + "assets/images/flowers@2x.f11f25da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/GuestBook/assets/flowers@2x.jpg
// module id = 1634
// module chunks = 0